<template>
<div id="contenedor-main-estadisticas">
  <v-skeleton-loader
    v-if="$apollo.loading"
    type="table-heading, table-thead, table-tbody"
  ></v-skeleton-loader>
  <v-container v-if="!$apollo.loading" fluid>
    <titulo-tool-bar
      :titulo="titulo"
      class="m-4">
      <template
        v-slot:opciones>
        <tool-bar
          :filtros="filtros"
          :listaContratos="getContratos">
        </tool-bar>
      </template>
    </titulo-tool-bar>
    <ExcelEstatusExpedientes
    v-show="false"
    ref="exportarEstatusExpedientes"
    :listaContratos="listadoContratos"
    :expedientes="getExpedientesTodos"
    />
    <div id="estadisticas">
      <v-card
        flat>
        <v-card-text>
          <v-row>
            <!-- Datos Estadisticos -->
            <template
            v-for="(estadistica, index) in getEstadisticasMostrar">
            <template>
              <v-col
                :key="`estadistica-${index}`"
                cols="6"
                md="3">
                <estadistica-card
                  :color="estadistica.color"
                  :color-estadistica="estadistica.colorEstadistica"
                  :dark="estadistica.dark"
                  :titulo="estadistica.titulo"
                  :estadistica="estadistica.estadistica">
                  <template
                    v-if="estadistica.subtitulo"
                    v-slot:subtitulo>
                    <v-chip
                      small>
                      {{ estadistica.subtitulo.dato | currency }}
                    </v-chip>
                  </template>
                  <template
                    v-slot:footer>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="estadistica.exportarExcel"
                        text
                        small
                        @click="$refs.exportarEstatusExpedientes.generarExcelExpedientes()">
                        <v-icon
                          left
                          small>
                          fa-file-excel
                        </v-icon>
                        Exportar Estatus
                      </v-btn>
                      <v-btn
                        v-if="estadistica.detalles"
                        text
                        small
                        @click="verDetalles(estadistica.detalles.tituloDetalles,
                        estadistica.detalles.contratosDetalles)">
                        <v-icon
                          left
                          small>
                          fa-info
                        </v-icon>
                        detalles
                      </v-btn>
                    </v-card-actions>
                  </template>
                </estadistica-card>
              </v-col>
            </template>
            </template>
            <!-- fin Datos Estadisticos -->
          </v-row>
          <tabla-programas
            v-if="mostrarTablaProgramas"
            :datos="mixProgramas"
            :avances="getAvances"
            @mostrar-detalles-tabla="mostrarDetallesPrograma">
          </tabla-programas>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
  <v-dialog
    v-model="detalle.mostrar"
    width="800"
    scrollable>
    <v-card>
      <v-card-title class="secondary--text">
        {{ detalle.titulo }}
        <v-spacer></v-spacer>
        <v-btn icon @click="detalle.mostrar = false">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <listado-detalle
          :listado="detalle.listado">
        </listado-detalle>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import CONTRATOS from '@/graphql/querys/administracion/contratos/estadisticas/contratos.gql';
import CONTRATOS_ESTATUS from '@/graphql/querys/administracion/catalogos/contratosestatus/contratosEstatus.gql';
import EXPEDEINTES from '@/graphql/querys/administracion/expediente/expedientes.gql';
import mixEstadisticasContratos from '@/helpers/mixEstadisticasContratos';
import ExcelEstatusExpedientes from '@/components/exportar/exceles/ExcelExpedientes.vue';
import TituloToolBar from '@/components/TituloToolBar.vue';
import TablaProgramas from './tablaPrograma.vue';
import ToolBar from './ToolBar.vue';
import EstadisticaCard from '@/components/EstadisticaCard.vue';
import ListadoDetalle from './ListadoDetalle.vue';

export default {
  name: 'MainEstadisticasContratos',
  mixins: [mixEstadisticasContratos],
  props: {
    titulo: {
      type: String,
      required: false,
      default: 'Estadisticas',
    },
    mostrarTablaProgramas: {
      type: Boolean,
      required: false,
      default: false,
    },
    datosMostrar: {
      type: Array,
      required: false,
    },
  },
  components: {
    TituloToolBar,
    ToolBar,
    EstadisticaCard,
    TablaProgramas,
    ListadoDetalle,
    ExcelEstatusExpedientes,
  },
  data() {
    return {
      detalle: {
        mostrar: false,
        titulo: '',
        listado: '',
      },
      filtros: {
        ejercicio: this.$ejercicioActual(),
        buscarTexto: '',
        tipos: [],
        financiamiento: 'Todos',
        programas: [],
        contratistas: [],
        supervisores: [],
        guardarFiltros: false,
      },
    };
  },
  apollo: {
    contratos: {
      query: CONTRATOS,
    },
    contratosEstatus: {
      query: CONTRATOS_ESTATUS,
    },
    expedientes: {
      query: EXPEDEINTES,
    },
  },
  methods: {
    verDetalles(estadistica, listado) {
      this.detalle.mostrar = true;
      this.detalle.titulo = estadistica;
      this.detalle.listado = listado;
    },
    mostrarDetallesPrograma(contratos, titulo) {
      // console.log(titulo);
      this.detalle.mostrar = true;
      this.detalle.titulo = titulo;
      this.detalle.listado = contratos;
    },
  },
  computed: {
    getTitulos() {
      return this.getDatosEstadisticos.map((dato) => dato.nombre);
    },
    getDatosEstadisticos() {
      return [
        {
          nombre: 'contatos',
          titulo: 'Contratos',
          color: '#a9b9df',
          estadistica: this.mixCantidadContratos,
          colorEstadistica: '',
          detalles: null,
          dark: false,
          subtitulo: {
            dato: this.$ObjSumar(this.mixContratos, 'total'),
          },
        },
        {
          nombre: 'conAnticipo',
          titulo: 'Con Anticipo',
          color: '#BBDEFB',
          estadistica: this.mixContratosConAnticipos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Anticipo',
            contratosDetalles: this.mixContratosConAnticipos,
          },
          dark: false,
        },
        {
          nombre: 'sinAnticipo',
          titulo: 'Sin Anticipo',
          color: '#BBDEFB',
          estadistica: this.mixContratosSinAnticipos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Sin Anticipo',
            contratosDetalles: this.mixContratosSinAnticipos,
          },
          dark: false,
        },
        {
          nombre: 'conAnticipoPorSolicitar',
          titulo: 'Anticipo por Sol.',
          color: '#BBDEFB',
          estadistica: this.mixContratosSinAnticipos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Anticipo por Solicitar',
            contratosDetalles: this.mixContratosSinAnticipos,
          },
          dark: false,
        },
        {
          nombre: 'conConvModificatorio',
          titulo: 'Con Conv Mod.',
          color: '#FFF9C4',
          estadistica: this.mixContratosConConveniosModificatorios.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Convenio Modificatorio',
            contratosDetalles: this.mixContratosConConveniosModificatorios,
          },
          dark: false,
        },
        {
          nombre: 'conPrograma',
          titulo: 'Con Programa',
          color: '#FFF9C4',
          estadistica: this.mixContratosConPrograma.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Programa',
            contratosDetalles: this.mixContratosConPrograma,
          },
          dark: false,
        },
        {
          nombre: 'sinPrograma',
          titulo: 'Sin Programa',
          color: '#FFF9C4',
          estadistica: this.mixContratosSinPrograma.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Sin Programa',
            contratosDetalles: this.mixContratosSinPrograma,
          },
          dark: false,
        },
        {
          nombre: 'conCatalogo',
          titulo: 'Con Catálogo',
          color: '#FFF9C4',
          estadistica: this.mixContratosConCatalogo.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Catálogo',
            contratosDetalles: this.mixContratosConCatalogo,
          },
          dark: false,
        },
        {
          nombre: 'sinCatalogo',
          titulo: 'Sin Catálogo',
          color: '#FFF9C4',
          estadistica: this.mixContratosSinCatalogo.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Sin Catálogo',
            contratosDetalles: this.mixContratosSinCatalogo,
          },
          dark: false,
        },
        {
          nombre: 'conExpediente',
          titulo: 'Con Expediente',
          color: '#FFCCBC',
          estadistica: this.mixContratosConExpedientes.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Expediente',
            contratosDetalles: this.mixContratosConExpedientes,
          },
          exportarExcel: true,
          dark: false,
        },
        {
          nombre: 'sinExpediente',
          titulo: 'Sin Expediente',
          color: '#FFCCBC',
          estadistica: this.mixContratosSinExpedientes.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Sin Expediente',
            contratosDetalles: this.mixContratosSinExpedientes,
          },
          dark: false,
        },
        {
          nombre: 'conExpedienteCompleto',
          titulo: 'Con Exp. Compl.',
          color: '#FFCCBC',
          estadistica: this.mixContratosConExpedientesComplementos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Expediente Completo',
            contratosDetalles: this.mixContratosConExpedientesComplementos,
          },
          dark: false,
        },
        {
          nombre: 'conExpedienteIncompleto',
          titulo: 'Con Exp. Incompl.',
          color: '#FFCCBC',
          estadistica: this.mixContratosConExpedientesIncomplementos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Con Expediente Incompleto',
            contratosDetalles: this.mixContratosConExpedientesIncomplementos,
          },
          dark: false,
        },
        {
          nombre: 'enEjecucion',
          titulo: 'En Ejecución',
          color: '#d0d0d0',
          estadistica: this.mixContratosEnEjecucion.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'En Ejecución',
            contratosDetalles: this.mixContratosEnEjecucion,
          },
          dark: false,
        },
        {
          nombre: 'sinAvFisico',
          titulo: 'Sin Av. Físico',
          color: '#d0d0d0',
          estadistica: this.mixContratosSinReporteFisico.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Sin Avance Físico',
            contratosDetalles: this.mixContratosSinReporteFisico,
          },
          dark: false,
        },
        {
          nombre: 'aTiempo',
          titulo: 'A Tiempo',
          color: '#d0d0d0',
          estadistica: this.mixContratosEnEjecucionAtiempo.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'A Tiempo',
            contratosDetalles: this.mixContratosEnEjecucionAtiempo,
          },
          dark: false,
        },
        {
          nombre: 'atrasadas',
          titulo: 'Atrasadas',
          color: '#d0d0d0',
          estadistica: this.mixContratosEnEjecucionconPocoAtraso.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Atrasadas',
            contratosDetalles: this.mixContratosEnEjecucionconPocoAtraso,
          },
          dark: false,
        },
        {
          nombre: 'muyAtrasadas',
          titulo: 'Muy Atrasadas',
          color: '#d0d0d0',
          estadistica: this.mixContratosEnEjecucionconMuyAtrasadas.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Muy Atrasadas',
            contratosDetalles: this.mixContratosEnEjecucionconMuyAtrasadas,
          },
          dark: false,
        },
        {
          nombre: 'terminados',
          titulo: 'Terminados',
          color: '#d0d0d0',
          estadistica: this.mixContratosEnEjecucionTerminadas.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Terminados',
            contratosDetalles: this.mixContratosEnEjecucionTerminadas,
          },
          dark: false,
        },
        {
          nombre: 'rescindidos',
          titulo: 'Rescindidos',
          color: '#d0d0d0',
          estadistica: this.mixContratosPorEstatus.Rescindido.contratos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Rescindidos',
            contratosDetalles: this.mixContratosPorEstatus.Rescindido.contratos,
          },
          dark: false,
        },
        {
          nombre: 'enObservacion',
          titulo: 'En Observación',
          color: '#d0d0d0',
          estadistica: this.mixContratosPorEstatus['En Observación'].contratos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'En Observación',
            contratosDetalles: this.mixContratosPorEstatus['En Observación'].contratos,
          },
          dark: false,
        },
        {
          nombre: 'terminacionAnticipada',
          titulo: 'Term. Anticipada',
          color: '#d0d0d0',
          estadistica: this.mixContratosPorEstatus['Terminado Anticipado'].contratos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Terminación Anticipada',
            contratosDetalles: this.mixContratosPorEstatus['Terminado Anticipado'].contratos,
          },
          dark: false,
        },
        {
          nombre: 'estatusEnEjecucion',
          titulo: 'Estatus en Ejecución',
          color: '#d0d0d0',
          estadistica: this.mixContratosPorEstatus['En Ejecución'].contratos.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Estatus en Ejecución',
            contratosDetalles: this.mixContratosPorEstatus['En Ejecución'].contratos,
          },
          dark: false,
        },
        {
          nombre: 'sinDeducciones',
          titulo: 'Sin Deducciones',
          color: '#FFF9C4',
          estadistica: this.mixContratosSinDeducciones.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Sin Deducciones',
            contratosDetalles: this.mixContratosSinDeducciones,
          },
          dark: false,
        },
        {
          nombre: 'conEstatusEjecucionSinReportesDeSupervision',
          titulo: 'Ejecución Sin Rep. de Sup.',
          color: '#d0d0d0',
          estadistica: this.mixContratosConEstatusEjecucionSinReportesDeSupervision.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Estatus en Ejecucion Sin Reportes de Supervisión',
            contratosDetalles: this.mixContratosConEstatusEjecucionSinReportesDeSupervision,
          },
          dark: false,
        },
        {
          nombre: 'enEjecucionSinReporteUltimaSemana',
          titulo: 'Ejecución Sin Rep. Ult. Sem.',
          color: '#d0d0d0',
          estadistica: this.mixContratosEjecucionSinReporteUltimaSemana.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Estatus en Ejecucion Sin Reportes Última Semana',
            contratosDetalles: this.mixContratosEjecucionSinReporteUltimaSemana,
          },
          dark: false,
        },
        {
          nombre: 'enEjecucionConProblemaUltimoReporte',
          titulo: 'Ejecución Problema Ult. Rep.',
          color: '#d0d0d0',
          estadistica: this.mixContratosEnEjecucionConProblemaUltimoReporte.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'En Ejecucion con Problema Último Reporte',
            contratosDetalles: this.mixContratosEnEjecucionConProblemaUltimoReporte,
          },
          dark: false,
        },
        {
          nombre: 'sinEstimaciones',
          titulo: 'Sin Estimaciones',
          color: '#a3c682',
          estadistica: this.mixContratosSinEstimaciones.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Sin Estimaciones',
            contratosDetalles: this.mixContratosSinEstimaciones,
          },
          dark: false,
        },
        {
          nombre: 'terminadosSinEstimacionFiniquito',
          titulo: 'Terminados Sin Est. Fin.',
          color: '#a3c682',
          estadistica: this.mixContratosTerminadosSinEstimacionFiniquito.length,
          colorEstadistica: '',
          detalles: {
            tituloDetalles: 'Terminados Sin Estimación Finiquito',
            contratosDetalles: this.mixContratosTerminadosSinEstimacionFiniquito,
          },
          dark: false,
        },
        {
          nombre: 'avanceProgramado',
          titulo: 'Avance Programado',
          color: 'naranja2',
          estadistica: `${this.$numberRound(this.getAvances.programado * 100)}%`,
          colorEstadistica: '',
          detalles: null,
          dark: false,
        },
        {
          nombre: 'avanceFisico',
          titulo: 'Avance Físico',
          color: 'azul1',
          estadistica: `${this.$numberRound(this.getAvances.fisico * 100)}%`,
          colorEstadistica: '',
          detalles: null,
          dark: false,
        },
        {
          nombre: 'avanceFinanciero',
          titulo: 'Avance Financiero',
          color: 'verde1',
          estadistica: `${this.$numberRound(this.getAvances.financiero * 100)}%`,
          colorEstadistica: '',
          detalles: null,
          dark: false,
        },

      ];
    },
    getEstadisticasMostrar() {
      if (!this.datosMostrar) return [];
      return this.getDatosEstadisticos
        .filter((datoEstadistico) => this.datosMostrar.includes(datoEstadistico.nombre))
        .sort((a, b) => (this.datosMostrar
          .indexOf(a.nombre) - this.datosMostrar
          .indexOf(b.nombre)));
    },
    getExpedientesTodos() {
      if (!this.expedientes) return [];
      return this.expedientes;
    },
    getContratos() {
      if (!this.contratos) return [];
      return this.contratos
      // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    listadoEstatusContratos() {
      if (!this.contratosEstatus) return [];
      return this.contratosEstatus;
    },
    listadoContratos() {
      if (!this.contratos) return [];
      const { contratos } = this;
      return contratos
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        // Sacar el ultimo reporte
        .map((contrato) => {
          const ultimoReporte = contrato.reportesFisicos
            .find(({ esUltimo }) => esUltimo === true);

          if (ultimoReporte) {
            ultimoReporte.avanceDiferencia = (ultimoReporte.avanceProgramado
            - ultimoReporte.avanceFisico);
          }

          return {
            ...contrato,
            ultimoReporte,
          };
        })
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        // Filtrar por ejercicio
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        });
    },
    getAvances() {
      return {
        programado: this.$sumar(this.mixContratos.map(({ avanceProgramado }) => avanceProgramado)),
        fisico: this.$sumar(this.mixContratos.map(({ avanceFisico }) => avanceFisico)),
        financiero: this.$sumar(this.mixContratos.map(({ avanceFinanciero }) => avanceFinanciero)),
      };
    },
  },
};
</script>

<style lang="scss">

</style>
